import { useMemo } from 'react';
import { graphApi } from '.';

const removeDiacritics = (str: string) =>
  str.normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const useFindCoWorkers = (
  search: string,
  {
    locations,
    excludeLocations,
  }: { locations?: string[]; excludeLocations?: string[] } = {}
) => {
  const searchStr = removeDiacritics(search.toLowerCase().trim());
  let locationFilter = '';

  if (locations?.length) {
    const locationList = locations.map((loc) => `'${loc}'`).join(',');
    locationFilter = `officeLocation in (${locationList})`;
  }

  if (excludeLocations?.length) {
    const locationList = excludeLocations.map((loc) => `'${loc}'`).join(',');
    locationFilter = `officeLocation ne ${locationList}`;
  }

  const { error, data, isLoading } = useFindGraphUsersQuery({
    filter: locationFilter,
    search: `"displayName:${searchStr}" OR "mail:${searchStr}"`,
    orderBy: 'displayName',
    select:
      'id,displayName,mail,givenName,surname,officeLocation,country,jobTitle',
  });

  const users = (data?.value || []).filter(({ displayName, mail }) => {
    if (!displayName || !mail) {
      return false;
    }

    const haystack = removeDiacritics(`${displayName} ${mail}`);
    return haystack.match(new RegExp(searchStr.trim(), 'i'));
  });

  return useMemo(
    () => ({ isLoading, error, data: users }),
    [users, isLoading, error]
  );
};

export const { useGetUserProfileImageQuery, useFindGraphUsersQuery } = graphApi;
